var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeoplePlus = function SvgPeoplePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.335 9.019a2.917 2.917 0 1 0 0-5.833 2.917 2.917 0 0 0 0 5.833v0ZM2.084 17.685v.5h12.5v-.5c0-1.867 0-2.8-.363-3.513a3.333 3.333 0 0 0-1.457-1.457c-.713-.363-1.647-.363-3.513-.363H7.417c-1.866 0-2.8 0-3.513.363-.627.32-1.137.83-1.457 1.457-.363.713-.363 1.646-.363 3.513ZM13.752 8.602h5m-2.5-2.5v5-5Z",
    stroke: "#6B7280",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPeoplePlus;